module.exports = __webpack_public_path__ + "img/Camera Icon - white.3e00c854.svg";